(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-cnc"] && !Shopify.designMode) return;
  try {
    
  class CncHeroSlider {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('.cnc-hero__slide'));
      this.interval = parseInt(root.dataset.autoplay, 10) || 6000;
      this.current = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.current < 0) this.current = 0;
      this.timer = null;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.slides.length > 1 && !reduceMotion) {
        this.start();
        // Bei Tab-Wechsel pausieren, um nicht im Hintergrund zu laufen
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stop();
          } else {
            this.start();
          }
        });
      }
    }

    show(index) {
      this.slides[this.current].classList.remove('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides[this.current].classList.add('is-active');
      this.slides[this.current].removeAttribute('aria-hidden');
    }

    next() {
      this.show(this.current + 1);
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  function initCncHeroSliders(scope) {
    (scope || document).querySelectorAll('[data-cnc-slider]').forEach((el) => {
      if (el.dataset.cncSliderInit === 'true') return;
      el.dataset.cncSliderInit = 'true';
      new CncHeroSlider(el);
    });
  }

  if (document.readyState !== 'loading') {
    initCncHeroSliders();
  } else {
    document.addEventListener('DOMContentLoaded', () => initCncHeroSliders());
  }

  // Theme-Editor: nach dem Laden/Bearbeiten einer Section neu initialisieren
  document.addEventListener('shopify:section:load', (event) => {
    initCncHeroSliders(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
